<div class="personal-webchat-setting-container" [class.embedded-mode]="isEmbeddedInDetail" testId="personal-webchat-setting-page">
  <nz-spin
    [nzSpinning]="loading || saving"
    [nzTip]="saving ? ('servicenumber.webchat.saving' | i18n) : ('common.loading' | i18n)"
    nzSize="large"
    testId="personal-webchat-setting-spin"
  >
    <div class="page" [class.mobile-mask-active]="showMobileDesktopPrompt" testId="personal-webchat-setting-content">
      <ng-template #floatSettingsPreviewTpl>
        <ng-template #floatPreviewTitle>
          <i nz-icon nzType="eye" nzTheme="outline" class="icon-eye"></i>
          {{ 'servicenumber.webchat.preview' | i18n }}
        </ng-template>
        <nz-card nzType="inner" class="float-preview-card" [nzTitle]="floatPreviewTitle">
          <div class="preview-area">
            <div class="page-mock">
              <div class="lines">
                <div class="line" style="width: 60%"></div>
                <div class="line" style="width: 80%"></div>
                <div class="line" style="width: 70%"></div>
                <div class="line" style="width: 50%"></div>
              </div>
              <div
                class="bubble-group"
                [ngClass]="[position || '', animationClass]"
                [style.bottom.px]="bottomOffset"
                [style.right.px]="position === 'right-bottom' ? rightOffset : null"
                [style.left.px]="position === 'left-bottom' ? leftOffset : null"
              >
                <div class="chat-bubble" [style.borderColor]="badgeColor">
                  <div class="bubble-text" nz-tooltip [nzTooltipTitle]="'servicenumber.webchat.previewTip' | i18n">
                    {{ 'servicenumber.webchat.previewMessage' | i18n }}
                  </div>
                  <span class="bubble-close" nz-icon nzType="close"></span>
                </div>
                <div class="bubble-avatar-wrap">
                  <img class="bubble-avatar" [src]="avatarUrl" [style.width.px]="bubbleSize" [style.height.px]="bubbleSize" />
                  <span class="bubble-badge" [style.background]="badgeColor">3</span>
                </div>
              </div>
            </div>
            <div class="preview-note">
              {{ 'servicenumber.webchat.previewNote' | i18n }}
            </div>
          </div>
        </nz-card>
      </ng-template>

      <!-- 顶部独立头部：标题、说明与操作按钮，不在 nz-card 内 -->
      <div class="topbar" testId="personal-webchat-setting-topbar">
        <div class="topbar-left" testId="personal-webchat-setting-heading">
          <div class="top-title" testId="personal-webchat-setting-title">{{ 'servicenumber.webchat.title' | i18n }}</div>
          <div class="top-desc" testId="personal-webchat-setting-description">{{ 'servicenumber.webchat.header.desc' | i18n }}</div>
        </div>
        <div class="header-actions" testId="personal-webchat-setting-header-actions">
          <button nz-button class="script-btn" (click)="openFloatPreviewModal()" testId="personal-webchat-setting-float-preview-button">
            <i nz-icon nzType="eye"></i>
            {{ 'servicenumber.webchat.preview' | i18n }}
          </button>
          <button nz-button nzType="primary" class="save-btn" (click)="onSave()" testId="personal-webchat-setting-save-button">
            <i nz-icon nzType="save"></i>
            {{ 'servicenumber.webchat.actions.save' | i18n }}
          </button>
          <span
            nz-tooltip
            [nzTooltipTitle]="integrationCodeUnavailableReason"
            [nzTooltipTrigger]="canOpenIntegrationCode ? null : 'hover'"
            class="script-btn-tooltip"
          >
            <button
              nz-button
              class="script-btn"
              (click)="openIntegrationCode()"
              [disabled]="!canOpenIntegrationCode"
              testId="personal-webchat-setting-integration-code-button"
            >
              <i nz-icon nzType="code"></i>
              {{ 'servicenumber.webchat.actions.getScript' | i18n }}
            </button>
          </span>
        </div>
      </div>

      <nz-modal
        [(nzVisible)]="floatPreviewModalVisible"
        nzClassName="webchat-float-preview-modal"
        [nzTitle]="''"
        [nzFooter]="null"
        [nzWidth]="'min(1240px, calc(100vw - 32px))'"
        [nzBodyStyle]="{ padding: '0' }"
        (nzOnCancel)="closeFloatPreviewModal()"
        testId="personal-webchat-float-preview-modal"
      >
        <ng-container *nzModalContent>
          <div class="webchat-float-preview-workbench" testId="personal-webchat-float-preview-workbench">
            <div class="webchat-float-preview-hero">
              <div class="webchat-float-preview-hero-copy">
                <span class="webchat-float-preview-hero-kicker">{{ 'servicenumber.webchat.preview' | i18n }}</span>
                <div class="webchat-float-preview-modal-title">{{ 'servicenumber.webchat.previewWorkspace.title' | i18n }}</div>
                <div class="webchat-float-preview-modal-desc">{{ 'servicenumber.webchat.previewWorkspace.desc' | i18n }}</div>
              </div>
            </div>
            <div class="webchat-float-preview-modal-actions" testId="personal-webchat-float-preview-actions">
              <div class="webchat-float-preview-browser-bar" aria-hidden="true">
                <span class="dot dot-red"></span>
                <span class="dot dot-yellow"></span>
                <span class="dot dot-green"></span>
                <div class="webchat-float-preview-browser-address">{{ 'servicenumber.webchat.previewWorkspace.address' | i18n }}</div>
              </div>
              <div class="webchat-float-preview-modal-buttons">
                <button nz-button type="button" (click)="refreshFloatPreviewModal()" testId="personal-webchat-float-preview-refresh-button">
                  {{ 'common.refresh' | i18n }}
                </button>
                <button nz-button type="button" (click)="closeFloatPreviewModal()" testId="personal-webchat-float-preview-close-button">
                  {{ 'common.close' | i18n }}
                </button>
              </div>
            </div>
            <div class="webchat-float-preview-stage" testId="personal-webchat-float-preview-stage">
              <div class="webchat-float-preview-stage-frame">
                <iframe
                  class="webchat-embed-preview-frame"
                  [attr.srcdoc]="floatPreviewSrcdoc"
                  sandbox="allow-scripts allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin"
                  referrerpolicy="no-referrer-when-downgrade"
                  testId="personal-webchat-float-preview-frame"
                ></iframe>
              </div>
            </div>
          </div>
        </ng-container>
      </nz-modal>

      <div class="unsaved-banner" *ngIf="unsavedStyleDirty && selectedTab === 1" testId="personal-webchat-setting-unsaved-banner">
        <span class="icon" nz-icon nzType="exclamation-circle" nzTheme="fill"></span>
        <div class="text">
          <div class="title">{{ 'servicenumber.webchat.unsaved.title' | i18n }}</div>
          <div class="desc">{{ 'servicenumber.webchat.unsaved.desc' | i18n }}</div>
        </div>
      </div>
      <div class="content-wrapper" testId="personal-webchat-setting-wrapper">
        <div class="webchat-page-surface" testId="personal-webchat-setting-surface">
          <section class="webchat-share-entry" testId="personal-webchat-setting-share-entry">
            <div class="webchat-share-main">
              <div class="webchat-share-title-row">
                <h3>{{ 'servicenumber.webchat.share.title' | i18n }}</h3>
                <nz-tag nzColor="blue">{{ 'servicenumber.webchat.share.stableTag' | i18n }}</nz-tag>
              </div>
              <div class="webchat-share-desc">{{ 'servicenumber.webchat.share.desc' | i18n }}</div>
            </div>
            <div class="webchat-share-actions">
              <button
                nz-button
                nzType="primary"
                (click)="openShareQrModal()"
                [disabled]="!currentWebchatShareUrl"
                testId="personal-webchat-setting-share-qr-button"
              >
                <i nz-icon nzType="qrcode"></i>
                {{ 'servicenumber.webchat.share.qrcode' | i18n }}
              </button>
              <button
                nz-button
                (click)="openShareLinkModal()"
                [disabled]="!currentWebchatShareUrl"
                testId="personal-webchat-setting-share-link-button"
              >
                <i nz-icon nzType="eye"></i>
                {{ 'servicenumber.webchat.share.fullLink' | i18n }}
              </button>
            </div>
          </section>
          <nz-tabset [(nzSelectedIndex)]="selectedTab" testId="personal-webchat-setting-tabs">
            <nz-tab nzTitle="{{ 'servicenumber.webchat.tab.featureConfig' | i18n }}" testId="personal-webchat-setting-feature-tab">
              <div class="feature-page-shell">
                <div class="tab-lead">
                  <div>
                    <h3 class="tab-lead-title">{{ 'servicenumber.webchat.feature.title' | i18n }}</h3>
                    <div class="tab-lead-desc">{{ 'servicenumber.webchat.feature.subtitle' | i18n }}</div>
                  </div>
                </div>
                <div class="feature-toolbar">
                  <div class="feature-page-meta">
                    <span class="feature-page-meta-pill strong">
                      {{ enabledFeatureCount }} {{ 'servicenumber.webchat.feature.status.enabled' | i18n }}
                    </span>
                    <span class="feature-page-meta-pill" [class.active]="serviceTermsConfig.enabled">
                      {{ 'servicenumber.webchat.feature.terms.switchTitle' | i18n }}
                    </span>
                  </div>
                </div>

                <!-- <div class="feature-info-card">
                  <div class="info-head">
                    <i nz-icon nzType="info-circle" nzTheme="fill"></i>
                    <span>{{ 'servicenumber.webchat.feature.guide.title' | i18n }}</span>
                  </div>
                  <ul class="feature-guide-list">
                    <li>{{ 'servicenumber.webchat.feature.guide.scope' | i18n }}</li>
                    <li>{{ 'servicenumber.webchat.feature.guide.effect' | i18n }}</li>
                    <li>{{ 'servicenumber.webchat.feature.guide.default' | i18n }}</li>
                    <li>{{ 'servicenumber.webchat.feature.guide.audit' | i18n }}</li>
                  </ul>
                </div> -->

                <div class="feature-unsaved-banner" *ngIf="hasUnsavedFeatureConfig">
                  <i nz-icon nzType="exclamation-circle" nzTheme="fill" class="icon"></i>
                  <span>{{ 'servicenumber.webchat.feature.unsavedHint' | i18n }}</span>
                </div>

                <div class="feature-page-frame">
                  <div class="feature-layout">
                    <div class="feature-main feature-settings-surface">
                      <section class="feature-section">
                        <div class="feature-section-header">
                          <div class="feature-section-icon">
                            <i nz-icon nzType="setting"></i>
                          </div>
                          <div class="feature-section-title">{{ 'servicenumber.webchat.feature.section.behavior' | i18n }}</div>
                        </div>
                        <div class="feature-item-list">
                          <ng-container *ngFor="let item of behaviorFeatureItems">
                            <div class="feature-item">
                              <div class="feature-item-main">
                                <div class="feature-item-left">
                                  <div class="feature-item-icon">
                                    <i nz-icon [nzType]="item.icon"></i>
                                  </div>
                                  <div class="feature-item-content">
                                    <div class="feature-item-title">{{ item.titleKey | i18n }}</div>
                                    <div class="feature-item-desc">{{ item.descKey | i18n }}</div>
                                  </div>
                                </div>
                              </div>
                              <nz-switch
                                class="feature-switch"
                                [ngModel]="featureConfig[item.key]"
                                (ngModelChange)="toggleFeatureConfig(item.key, $event)"
                                [ngModelOptions]="{ standalone: true }"
                                [testId]="'personal-webchat-behavior-feature-switch-' + item.key"
                              />
                            </div>
                          </ng-container>
                          <div class="feature-item">
                            <div class="feature-item-main">
                              <div class="feature-item-left">
                                <div class="feature-item-icon">
                                  <i nz-icon nzType="api"></i>
                                </div>
                                <div class="feature-item-content">
                                  <div class="feature-item-title">{{ 'servicenumber.webchat.feature.postMessage.title' | i18n }}</div>
                                  <div class="feature-item-desc">{{ 'servicenumber.webchat.feature.postMessage.desc' | i18n }}</div>
                                </div>
                              </div>
                            </div>
                            <nz-switch
                              class="feature-switch"
                              [ngModel]="postMessageConfig.enabled"
                              (ngModelChange)="onPostMessageConfigChange($event)"
                              [ngModelOptions]="{ standalone: true }"
                              testId="personal-webchat-post-message-switch"
                            />
                          </div>
                        </div>
                      </section>

                      <section class="feature-section">
                        <div class="feature-section-header">
                          <div class="feature-section-icon feature-section-icon-terms">
                            <i nz-icon nzType="file-text"></i>
                          </div>
                          <div>
                            <div class="feature-section-title">{{ 'servicenumber.webchat.feature.terms.title' | i18n }}</div>
                            <div class="feature-section-desc">{{ 'servicenumber.webchat.feature.terms.subtitle' | i18n }}</div>
                          </div>
                        </div>

                        <div class="feature-item feature-item-expanded">
                          <div class="feature-item-main">
                            <div class="feature-item-left">
                              <div class="feature-item-content">
                                <div class="feature-item-title">{{ 'servicenumber.webchat.feature.terms.switchTitle' | i18n }}</div>
                                <div class="feature-item-desc">{{ 'servicenumber.webchat.feature.terms.switchDesc' | i18n }}</div>
                              </div>
                            </div>
                          </div>
                          <nz-switch
                            class="feature-switch"
                            [ngModel]="serviceTermsConfig.enabled"
                            (ngModelChange)="onServiceTermsConfigChange('enabled', $event)"
                            [ngModelOptions]="{ standalone: true }"
                            testId="personal-webchat-service-terms-switch"
                          />
                        </div>

                        <div class="service-terms-form" *ngIf="serviceTermsConfig.enabled">
                          <div class="service-terms-grid">
                            <div class="service-terms-field">
                              <div class="service-terms-label">{{ 'servicenumber.webchat.feature.terms.form.title' | i18n }}</div>
                              <input
                                nz-input
                                [ngModel]="serviceTermsConfig.title"
                                (ngModelChange)="onServiceTermsConfigChange('title', $event)"
                                [ngModelOptions]="{ standalone: true }"
                                testId="personal-webchat-service-terms-title-input"
                              />
                            </div>
                            <div class="service-terms-field">
                              <div class="service-terms-label">{{ 'servicenumber.webchat.feature.terms.form.version' | i18n }}</div>
                              <input
                                nz-input
                                [ngModel]="serviceTermsConfig.version"
                                (ngModelChange)="onServiceTermsConfigChange('version', $event)"
                                [ngModelOptions]="{ standalone: true }"
                                testId="personal-webchat-service-terms-version-input"
                              />
                            </div>
                            <div class="service-terms-field service-terms-field-full">
                              <div class="service-terms-label">{{ 'servicenumber.webchat.feature.terms.form.content' | i18n }}</div>
                              <textarea
                                nz-input
                                rows="6"
                                [placeholder]="'servicenumber.webchat.feature.terms.form.contentPlaceholder' | i18n"
                                [ngModel]="serviceTermsConfig.content"
                                (ngModelChange)="onServiceTermsConfigChange('content', $event)"
                                testId="personal-webchat-service-terms-content-textarea"
                                [ngModelOptions]="{ standalone: true }"
                              ></textarea>
                            </div>
                            <div class="service-terms-field">
                              <div class="service-terms-label">{{ 'servicenumber.webchat.feature.terms.form.agree' | i18n }}</div>
                              <input
                                nz-input
                                [ngModel]="serviceTermsConfig.agreeButtonText"
                                (ngModelChange)="onServiceTermsConfigChange('agreeButtonText', $event)"
                                [ngModelOptions]="{ standalone: true }"
                                testId="personal-webchat-service-terms-agree-text-input"
                              />
                            </div>
                            <div class="service-terms-field">
                              <div class="service-terms-label">{{ 'servicenumber.webchat.feature.terms.form.cancel' | i18n }}</div>
                              <input
                                nz-input
                                [ngModel]="serviceTermsConfig.cancelButtonText"
                                (ngModelChange)="onServiceTermsConfigChange('cancelButtonText', $event)"
                                [ngModelOptions]="{ standalone: true }"
                                testId="personal-webchat-service-terms-cancel-text-input"
                              />
                            </div>
                          </div>

                          <div class="service-terms-notice">
                            {{ 'servicenumber.webchat.feature.terms.notice' | i18n }}
                          </div>
                        </div>
                      </section>

                      <section class="feature-section">
                        <div class="feature-section-header">
                          <div class="feature-section-icon feature-section-icon-terms">
                            <i nz-icon nzType="info-circle"></i>
                          </div>
                          <div>
                            <div class="feature-section-title">{{ 'servicenumber.webchat.feature.about.title' | i18n }}</div>
                            <div class="feature-section-desc">{{ 'servicenumber.webchat.feature.about.subtitle' | i18n }}</div>
                          </div>
                        </div>

                        <div class="service-terms-form">
                          <div class="service-terms-grid">
                            <div class="service-terms-field">
                              <div class="service-terms-label">{{ 'servicenumber.webchat.feature.about.form.title' | i18n }}</div>
                              <input
                                nz-input
                                [placeholder]="'servicenumber.webchat.feature.about.defaultTitle' | i18n"
                                [ngModel]="aboutConfig.title"
                                (ngModelChange)="onAboutConfigChange('title', $event)"
                                [ngModelOptions]="{ standalone: true }"
                                testId="personal-webchat-about-title-input"
                              />
                            </div>
                            <div class="service-terms-field service-terms-field-full">
                              <div class="service-terms-label">
                                {{ 'servicenumber.webchat.feature.about.form.versionDescription' | i18n }}
                              </div>
                              <textarea
                                nz-input
                                rows="4"
                                [placeholder]="'servicenumber.webchat.feature.about.defaultVersionDescription' | i18n"
                                [ngModel]="aboutConfig.versionDescription"
                                (ngModelChange)="onAboutConfigChange('versionDescription', $event)"
                                [ngModelOptions]="{ standalone: true }"
                                testId="personal-webchat-about-version-description-textarea"
                              ></textarea>
                            </div>
                          </div>
                          <div class="service-terms-notice" *ngIf="showAboutDefaultPreviewNotice">
                            {{ 'servicenumber.webchat.feature.about.defaultPreviewNotice' | i18n }}
                          </div>
                          <div class="service-terms-notice" *ngIf="showAboutClearFallbackNotice">
                            {{ 'servicenumber.webchat.feature.about.clearFallbackNotice' | i18n }}
                          </div>
                        </div>
                      </section>

                      <section class="feature-section">
                        <div class="feature-section-header">
                          <div class="feature-section-icon feature-section-icon-display">
                            <i nz-icon nzType="user"></i>
                          </div>
                          <div class="feature-section-title">{{ 'servicenumber.webchat.feature.section.display' | i18n }}</div>
                        </div>
                        <div class="feature-item-list">
                          <div class="feature-item" *ngFor="let item of displayFeatureItems">
                            <div class="feature-item-left">
                              <div class="feature-item-icon" [ngClass]="'feature-item-icon-' + item.key">
                                <i nz-icon [nzType]="item.icon"></i>
                              </div>
                              <div>
                                <div class="feature-item-title">{{ item.titleKey | i18n }}</div>
                                <div class="feature-item-desc">{{ item.descKey | i18n }}</div>
                              </div>
                            </div>
                            <nz-switch
                              class="feature-switch"
                              [ngModel]="featureConfig[item.key]"
                              (ngModelChange)="toggleFeatureConfig(item.key, $event)"
                              [ngModelOptions]="{ standalone: true }"
                              [testId]="'personal-webchat-display-feature-switch-' + item.key"
                            />
                          </div>
                        </div>
                      </section>
                    </div>

                    <div class="feature-side feature-preview-surface">
                      <section class="feature-side-panel">
                        <div class="feature-status-head">
                          <i nz-icon nzType="safety-certificate" class="feature-status-head-icon"></i>
                          <span>{{ 'servicenumber.webchat.feature.status.title' | i18n }}</span>
                        </div>
                        <div class="feature-status-summary">
                          <div class="feature-status-metric">
                            <div class="value enabled">{{ enabledFeatureCount }}</div>
                            <div class="label">{{ 'servicenumber.webchat.feature.status.enabled' | i18n }}</div>
                          </div>
                          <div class="feature-status-metric">
                            <div class="value disabled">{{ disabledFeatureCount }}</div>
                            <div class="label">{{ 'servicenumber.webchat.feature.status.disabled' | i18n }}</div>
                          </div>
                        </div>
                        <div class="feature-status-list-title">{{ 'servicenumber.webchat.feature.status.listTitle' | i18n }}</div>
                        <div class="feature-status-list">
                          <div class="feature-status-row" *ngFor="let item of featureItems">
                            <span>{{ item.titleKey | i18n }}</span>
                            <nz-tag [nzColor]="featureConfig[item.key] ? 'green' : 'default'">
                              {{
                                (featureConfig[item.key]
                                  ? 'servicenumber.webchat.feature.status.rowEnabled'
                                  : 'servicenumber.webchat.feature.status.rowDisabled'
                                ) | i18n
                              }}
                            </nz-tag>
                          </div>
                          <div class="feature-status-row">
                            <span>{{ 'servicenumber.webchat.feature.terms.switchTitle' | i18n }}</span>
                            <nz-tag [nzColor]="serviceTermsConfig.enabled ? 'green' : 'default'">
                              {{
                                (serviceTermsConfig.enabled
                                  ? 'servicenumber.webchat.feature.status.rowEnabled'
                                  : 'servicenumber.webchat.feature.status.rowDisabled'
                                ) | i18n
                              }}
                            </nz-tag>
                          </div>
                          <div class="feature-status-row">
                            <span>{{ 'servicenumber.webchat.feature.postMessage.title' | i18n }}</span>
                            <nz-tag [nzColor]="postMessageConfig.enabled ? 'green' : 'default'">
                              {{
                                (postMessageConfig.enabled
                                  ? 'servicenumber.webchat.feature.status.rowEnabled'
                                  : 'servicenumber.webchat.feature.status.rowDisabled'
                                ) | i18n
                              }}
                            </nz-tag>
                          </div>
                        </div>
                      </section>

                      <section class="feature-side-panel feature-preview-panel">
                        <div class="feature-status-head">
                          <i nz-icon nzType="file-done" class="feature-status-head-icon"></i>
                          <span>{{ 'servicenumber.webchat.feature.terms.previewTitle' | i18n }}</span>
                        </div>
                        <div class="service-terms-preview-shell">
                          <div class="service-terms-preview">
                            <div class="service-terms-preview-title">
                              {{ serviceTermsConfig.title || ('servicenumber.webchat.feature.terms.defaultTitle' | i18n) }}
                            </div>
                            <div class="service-terms-preview-content">
                              {{ serviceTermsConfig.content || ('servicenumber.webchat.feature.terms.previewPlaceholder' | i18n) }}
                            </div>
                            <div class="service-terms-preview-actions">
                              <button
                                nz-button
                                class="cancel-btn"
                                *ngIf="hasServiceTermsCancelButton()"
                                testId="personal-webchat-preview-terms-cancel-button"
                              >
                                {{ serviceTermsConfig.cancelButtonText }}
                              </button>
                              <button nz-button nzType="primary" class="agree-btn" testId="personal-webchat-preview-terms-agree-button">
                                {{ serviceTermsConfig.agreeButtonText || ('servicenumber.webchat.feature.terms.defaultAgree' | i18n) }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </section>

                      <section class="feature-side-panel feature-preview-panel">
                        <div class="feature-status-head">
                          <i nz-icon nzType="info-circle" class="feature-status-head-icon"></i>
                          <span>{{ 'servicenumber.webchat.feature.about.title' | i18n }}</span>
                        </div>
                        <div class="service-terms-preview-shell">
                          <div class="service-terms-preview">
                            <div class="service-terms-preview-title">
                              {{ aboutConfig.title || ('servicenumber.webchat.feature.about.defaultTitle' | i18n) }}
                            </div>
                            <div class="service-terms-preview-content">
                              {{
                                aboutConfig.versionDescription || ('servicenumber.webchat.feature.about.defaultVersionDescription' | i18n)
                              }}
                            </div>
                          </div>
                        </div>
                      </section>

                      <div class="feature-permission-card">
                        <div class="feature-permission-head">
                          <i nz-icon nzType="warning" class="feature-permission-icon"></i>
                          <span>{{ 'servicenumber.webchat.feature.permission.title' | i18n }}</span>
                        </div>
                        <div class="feature-permission-desc">{{ 'servicenumber.webchat.feature.permission.desc' | i18n }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nz-tab>
            <nz-tab
              nzTitle="{{ 'servicenumber.webchat.tab.floatButtonStyle' | i18n }}"
              [testId]="'personal-webchat-tab-float-button-style'"
            >
              <ng-template #floatSettingsMainTpl>
                <nz-card nzType="inner" [nzTitle]="'servicenumber.webchat.section.floatIcon' | i18n">
                  <div class="avatar-row">
                    <div class="avatar-block">
                      <img class="avatar" [src]="avatarUrl" alt="avatar" />
                      <div class="avatar-label">{{ 'servicenumber.webchat.avatarLabel' | i18n }}</div>
                    </div>
                    <div class="upload-block">
                      <nz-upload
                        nzType="drag"
                        [nzShowUploadList]="false"
                        [nzMultiple]="false"
                        [nzAccept]="'image/*'"
                        [nzCustomRequest]="handleUpload"
                        testId="personal-webchat-float-icon-upload"
                      >
                        <div class="upload-drag">
                          <span class="upload-icon" nz-icon nzType="inbox"></span>
                          <p class="upload-text">{{ 'servicenumber.webchat.uploadTip' | i18n }}</p>
                        </div>
                      </nz-upload>
                    </div>
                  </div>
                </nz-card>

                <nz-card nzType="inner" [nzTitle]="'servicenumber.webchat.section.position' | i18n" class="mt16">
                  <div class="position-row">
                    <button
                      nz-button
                      [ngClass]="{ active: position === 'left-bottom' }"
                      (click)="setPosition('left-bottom')"
                      testId="personal-webchat-position-left-button"
                      >{{ 'servicenumber.webchat.leftBottom' | i18n }}</button
                    >
                    <button
                      nz-button
                      [ngClass]="{ active: position === 'right-bottom' }"
                      (click)="setPosition('right-bottom')"
                      testId="personal-webchat-position-right-button"
                      >{{ 'servicenumber.webchat.rightBottom' | i18n }}</button
                    >
                  </div>
                </nz-card>

                <nz-card nzType="inner" class="mt16" [nzTitle]="'servicenumber.webchat.section.margin' | i18n">
                  <div class="grid two">
                    <div nz-form-item class="span-2">
                      <div nz-form-label>
                        <label>{{ 'servicenumber.webchat.margin.bottom' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <div style="display: flex; align-items: center; gap: 8px">
                          <nz-input-number
                            [(ngModel)]="bottomOffset"
                            (ngModelChange)="onFloatStyleChanged()"
                            name="bottomOffset"
                            [nzMin]="0"
                            [nzMax]="500"
                            style="flex: 1"
                            testId="personal-webchat-bottom-offset-input"
                          />
                          <span>{{ 'servicenumber.webchat.unit.px' | i18n }}</span>
                        </div>
                      </div>
                    </div>
                    <div nz-form-item class="span-2" *ngIf="position === 'right-bottom'">
                      <div nz-form-label>
                        <label>{{ 'servicenumber.webchat.margin.right' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <div style="display: flex; align-items: center; gap: 8px">
                          <nz-input-number
                            [(ngModel)]="rightOffset"
                            (ngModelChange)="onFloatStyleChanged()"
                            name="rightOffset"
                            [nzMin]="0"
                            [nzMax]="500"
                            style="flex: 1"
                            testId="personal-webchat-right-offset-input"
                          />
                          <span>{{ 'servicenumber.webchat.unit.px' | i18n }}</span>
                        </div>
                      </div>
                    </div>
                    <div nz-form-item class="span-2" *ngIf="position === 'left-bottom'">
                      <div nz-form-label>
                        <label>{{ 'servicenumber.webchat.margin.left' | i18n }}</label>
                      </div>
                      <div nz-form-control>
                        <div style="display: flex; align-items: center; gap: 8px">
                          <nz-input-number
                            [(ngModel)]="leftOffset"
                            (ngModelChange)="onFloatStyleChanged()"
                            name="leftOffset"
                            [nzMin]="0"
                            [nzMax]="500"
                            style="flex: 1"
                            testId="personal-webchat-left-offset-input"
                          />
                          <span>{{ 'servicenumber.webchat.unit.px' | i18n }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </nz-card>

                <nz-card nzType="inner" [nzTitle]="'servicenumber.webchat.section.size' | i18n" class="mt16">
                  <nz-radio-group
                    [(ngModel)]="buttonSize"
                    (ngModelChange)="onFloatStyleChanged()"
                    class="size-radio"
                    testId="personal-webchat-button-size-radio-group"
                  >
                    <label nz-radio-button nzValue="small">
                      <span class="main">{{ 'servicenumber.webchat.size.small' | i18n }}</span>
                      <span class="sub">50px</span>
                    </label>
                    <label nz-radio-button nzValue="medium">
                      <span class="main">{{ 'servicenumber.webchat.size.medium' | i18n }}</span>
                      <span class="sub">60px</span>
                    </label>
                    <label nz-radio-button nzValue="large">
                      <span class="main">{{ 'servicenumber.webchat.size.large' | i18n }}</span>
                      <span class="sub">70px</span>
                    </label>
                  </nz-radio-group>
                </nz-card>

                <nz-card nzType="inner" [nzTitle]="'servicenumber.webchat.section.themeColor' | i18n" class="mt16">
                  <div class="theme-row">
                    <input
                      type="color"
                      [(ngModel)]="badgeColor"
                      (ngModelChange)="onFloatStyleChanged()"
                      class="color-picker"
                      testId="personal-webchat-badge-color-picker"
                    />
                    <input
                      nz-input
                      [(ngModel)]="badgeColor"
                      (ngModelChange)="onFloatStyleChanged()"
                      placeholder="#1890ff"
                      class="color-input"
                      testId="personal-webchat-badge-color-input"
                    />
                  </div>
                </nz-card>

                <nz-card nzType="inner" [nzTitle]="'servicenumber.webchat.section.animations' | i18n" class="mt16">
                  <div class="anim-row">
                    <button
                      nz-button
                      [ngClass]="{ active: animation === 'none' }"
                      (click)="setAnimation('none')"
                      testId="personal-webchat-animation-none-button"
                    >
                      {{ 'servicenumber.webchat.anim.none' | i18n }}
                    </button>
                    <button
                      nz-button
                      [ngClass]="{ active: animation === 'pulse' }"
                      (click)="setAnimation('pulse')"
                      testId="personal-webchat-animation-pulse-button"
                    >
                      {{ 'servicenumber.webchat.anim.pulse' | i18n }}
                    </button>
                    <button
                      nz-button
                      [ngClass]="{ active: animation === 'bounce' }"
                      (click)="setAnimation('bounce')"
                      testId="personal-webchat-animation-bounce-button"
                    >
                      {{ 'servicenumber.webchat.anim.bounce' | i18n }}
                    </button>
                    <button
                      nz-button
                      [ngClass]="{ active: animation === 'shake' }"
                      (click)="setAnimation('shake')"
                      testId="personal-webchat-animation-shake-button"
                    >
                      {{ 'servicenumber.webchat.anim.shake' | i18n }}
                    </button>
                  </div>
                </nz-card>
              </ng-template>

              <div class="grid two float-settings-shell">
                <div class="tab-lead tab-lead-inline span-2">
                  <div>
                    <h3 class="tab-lead-title">{{ 'servicenumber.webchat.tab.floatButtonStyle' | i18n }}</h3>
                    <div class="tab-lead-desc">{{ 'servicenumber.webchat.preview' | i18n }}</div>
                  </div>
                </div>
                <ng-container *ngIf="!isCompactViewport; else compactFloatSettingsLayout">
                  <div class="left float-settings-main">
                    <ng-container [ngTemplateOutlet]="floatSettingsMainTpl" />
                  </div>

                  <div class="right float-settings-preview">
                    <ng-container [ngTemplateOutlet]="floatSettingsPreviewTpl" />
                  </div>
                </ng-container>

                <ng-template #compactFloatSettingsLayout>
                  <div class="float-settings-main compact-float-settings-main">
                    <ng-container [ngTemplateOutlet]="floatSettingsMainTpl" />
                  </div>

                  <div class="float-settings-preview compact-float-settings-preview">
                    <ng-container [ngTemplateOutlet]="floatSettingsPreviewTpl" />
                  </div>
                </ng-template>
              </div>
            </nz-tab>

            <nz-tab nzTitle="{{ 'servicenumber.webchat.tab.themeMode' | i18n }}" [testId]="'personal-webchat-tab-theme-mode'">
              <div nzType="inner" class="theme-wrapper-card theme-settings-shell">
                <div class="tab-lead tab-lead-inline">
                  <div>
                    <h3 class="tab-lead-title">{{ 'servicenumber.webchat.tab.themeMode' | i18n }}</h3>
                    <div class="tab-lead-desc">{{ 'theme.item.preview.title' | i18n }}</div>
                  </div>
                </div>
                <div class="theme-editor editor-layout">
                  <!-- 左側：主題表單 -->
                  <div class="form-column">
                    <div class="form-scroll">
                      <form class="form" testId="personal-webchat-theme-form">
                        <!-- 主題選擇區塊 -->
                        <div class="section-card">
                          <h3 class="section-title">{{ 'theme.item.preset.selectTitle' | i18n }}</h3>
                          <div nz-form-item class="span-2">
                            <div nz-form-control class="theme-selector">
                              <nz-select
                                class="theme-full-select"
                                [(ngModel)]="selectedThemeId"
                                (ngModelChange)="onThemeSelected($event)"
                                name="selectedThemeId"
                                [nzPlaceHolder]="'theme.item.preset.selectPlaceholder' | i18n"
                                testId="personal-webchat-theme-preset-select"
                              >
                                <nz-option *ngFor="let opt of themeOptions" [nzValue]="opt.id" [nzLabel]="opt.name" />
                              </nz-select>
                              <div class="selector-desc">
                                {{ 'theme.item.preset.selectDesc' | i18n }}
                              </div>
                              <div class="theme-palette-strip">
                                <div class="theme-palette-chip">
                                  <span class="swatch" [style.background]="primaryColor"></span>
                                  <span class="label">{{ 'theme.item.field.primary-color' | i18n }}</span>
                                </div>
                                <div class="theme-palette-chip">
                                  <span class="swatch" [style.background]="backgroundColor"></span>
                                  <span class="label">{{ 'theme.item.field.background-color' | i18n }}</span>
                                </div>
                                <div class="theme-palette-chip">
                                  <span class="swatch" [style.background]="headerTextColor"></span>
                                  <span class="label">{{ 'theme.item.field.header-text-color' | i18n }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="section-card">
                          <h3 class="section-title">{{ 'theme.item.section.base-colors' | i18n }}</h3>
                          <div class="grid two">
                            <div nz-form-item>
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.primary-color' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="primaryColor"
                                    name="primaryColorPicker"
                                    testId="personal-webchat-theme-primary-color-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="primaryColor"
                                    name="primaryColor"
                                    testId="personal-webchat-theme-primary-color-input"
                                  />
                                </div>
                              </div>
                            </div>
                            <div nz-form-item>
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.background-color' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="backgroundColor"
                                    name="backgroundColorPicker"
                                    testId="personal-webchat-theme-background-color-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="backgroundColor"
                                    name="backgroundColor"
                                    testId="personal-webchat-theme-background-color-input"
                                  />
                                </div>
                              </div>
                            </div>
                            <div nz-form-item class="span-2">
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.header-text-color' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="headerTextColor"
                                    name="headerTextColorPicker"
                                    testId="personal-webchat-theme-header-text-color-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="headerTextColor"
                                    name="headerTextColor"
                                    testId="personal-webchat-theme-header-text-color-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="section-card">
                          <h3 class="section-title">{{ 'theme.item.section.bubbles' | i18n }}</h3>
                          <div class="grid two">
                            <div nz-form-item>
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.user-message-bg' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="customerBubbleBg"
                                    name="customerBubbleBgPicker"
                                    testId="personal-webchat-theme-customer-bubble-bg-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="customerBubbleBg"
                                    name="customerBubbleBg"
                                    testId="personal-webchat-theme-customer-bubble-bg-input"
                                  />
                                </div>
                              </div>
                            </div>
                            <div nz-form-item>
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.user-message-text' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="customerBubbleText"
                                    name="customerBubbleTextPicker"
                                    testId="personal-webchat-theme-customer-bubble-text-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="customerBubbleText"
                                    name="customerBubbleText"
                                    testId="personal-webchat-theme-customer-bubble-text-input"
                                  />
                                </div>
                              </div>
                            </div>
                            <div nz-form-item>
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.service-message-bg' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="agentBubbleBg"
                                    name="agentBubbleBgPicker"
                                    testId="personal-webchat-theme-agent-bubble-bg-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="agentBubbleBg"
                                    name="agentBubbleBg"
                                    testId="personal-webchat-theme-agent-bubble-bg-input"
                                  />
                                </div>
                              </div>
                            </div>
                            <div nz-form-item>
                              <div nz-form-label>
                                <label>{{ 'theme.item.field.service-message-text' | i18n }}</label>
                              </div>
                              <div nz-form-control>
                                <div class="color-input-pair">
                                  <input
                                    type="color"
                                    [(ngModel)]="agentBubbleText"
                                    name="agentBubbleTextPicker"
                                    testId="personal-webchat-theme-agent-bubble-text-picker"
                                  />
                                  <input
                                    nz-input
                                    [(ngModel)]="agentBubbleText"
                                    name="agentBubbleText"
                                    testId="personal-webchat-theme-agent-bubble-text-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <details class="theme-advanced">
                          <summary class="theme-advanced-summary">
                            <div>
                              <div class="theme-advanced-title">{{ 'theme.item.advanced.title' | i18n }}</div>
                              <div class="theme-advanced-desc">{{ 'theme.item.advanced.desc' | i18n }}</div>
                            </div>
                            <span class="theme-advanced-toggle"></span>
                          </summary>

                          <div class="theme-advanced-content">
                            <div class="section-card">
                              <h3 class="section-title">{{ 'theme.item.section.ui-elements' | i18n }}</h3>
                              <div class="grid two">
                                <div nz-form-item>
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.field.header-bg' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <div class="color-input-pair">
                                      <input
                                        type="color"
                                        [(ngModel)]="headerBg"
                                        name="headerBgPicker"
                                        testId="personal-webchat-theme-header-bg-picker"
                                      />
                                      <input
                                        nz-input
                                        [(ngModel)]="headerBg"
                                        name="headerBg"
                                        testId="personal-webchat-theme-header-bg-input"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div nz-form-item>
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.field.footer-bg' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <div class="color-input-pair">
                                      <input
                                        type="color"
                                        [(ngModel)]="footerBg"
                                        name="footerBgPicker"
                                        testId="personal-webchat-theme-footer-bg-picker"
                                      />
                                      <input
                                        nz-input
                                        [(ngModel)]="footerBg"
                                        name="footerBg"
                                        testId="personal-webchat-theme-footer-bg-input"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="section-card">
                              <h3 class="section-title">{{ 'theme.item.section.radius-shadow' | i18n }}</h3>
                              <div class="grid two">
                                <div nz-form-item>
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.field.bubble-radius' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <input
                                      nz-input
                                      [(ngModel)]="bubbleRadius"
                                      name="bubbleRadius"
                                      testId="personal-webchat-theme-bubble-radius-input"
                                    />
                                  </div>
                                </div>
                                <div nz-form-item>
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.field.window-radius' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <input
                                      nz-input
                                      [(ngModel)]="windowRadius"
                                      name="windowRadius"
                                      testId="personal-webchat-theme-window-radius-input"
                                    />
                                  </div>
                                </div>
                                <div nz-form-item class="span-2">
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.shadow.title' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <nz-select
                                      class="theme-full-select"
                                      [(ngModel)]="shadowPreset"
                                      (ngModelChange)="onShadowPresetChange($event)"
                                      name="boxShadowPreset"
                                      testId="personal-webchat-theme-shadow-preset-select"
                                    >
                                      <nz-option [nzValue]="'none'" [nzLabel]="'theme.item.shadow.preset.none' | i18n" />
                                      <nz-option [nzValue]="'light'" [nzLabel]="'theme.item.shadow.preset.light' | i18n" />
                                      <nz-option [nzValue]="'standard'" [nzLabel]="'theme.item.shadow.preset.standard' | i18n" />
                                      <nz-option [nzValue]="'deep'" [nzLabel]="'theme.item.shadow.preset.deep' | i18n" />
                                      <nz-option [nzValue]="'custom'" [nzLabel]="'theme.item.shadow.preset.custom' | i18n" />
                                    </nz-select>
                                  </div>
                                </div>
                                <div nz-form-item class="span-2" *ngIf="shadowPreset === 'custom'">
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.shadow.custom-placeholder' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <input
                                      nz-input
                                      class="theme-muted-input"
                                      [(ngModel)]="boxShadowMedium"
                                      name="boxShadowCustom"
                                      [placeholder]="'theme.item.shadow.custom-placeholder' | i18n"
                                      testId="personal-webchat-theme-shadow-custom-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="section-card">
                              <h3 class="section-title">{{ 'theme.item.font.title' | i18n }}</h3>
                              <div class="grid two">
                                <div nz-form-item class="span-2">
                                  <div nz-form-label>
                                    <label>{{ 'theme.item.font.size.message' | i18n }}</label>
                                  </div>
                                  <div nz-form-control>
                                    <input
                                      nz-input
                                      [(ngModel)]="fontSizeBase"
                                      name="fontSizeBase"
                                      testId="personal-webchat-theme-font-size-base-input"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </details>
                      </form>
                    </div>
                  </div>

                  <!-- 右側：預覽 -->
                  <div class="preview-column">
                    <div class="section-card preview-card">
                      <h3 class="section-title">
                        <i nz-icon nzType="eye" nzTheme="outline" class="icon-eye"></i>{{ 'theme.item.preview.title' | i18n }}
                      </h3>
                      <div
                        class="chat-preview"
                        [style.background]="backgroundColor"
                        [style.box-shadow]="boxShadowMedium"
                        [style.border-radius]="windowRadius"
                        [style.--preview-primary-color]="primaryColor"
                      >
                        <div class="chat-header" [style.background]="headerBg" [style.color]="headerTextColor">
                          <span class="avatar"></span>
                          <div class="header-info">
                            <div class="name">{{ 'theme.item.preview.header' | i18n }}</div>
                            <div class="status">{{ 'theme.item.preview.status.online' | i18n }}</div>
                          </div>
                        </div>
                        <div class="chat-messages" [style.font-size]="fontSizeBase">
                          <div class="message-row service">
                            <span class="avatar"></span>
                            <div
                              class="message service"
                              [style.background]="agentBubbleBg"
                              [style.color]="agentBubbleText"
                              [style.border-radius]="bubbleRadius"
                              [style.box-shadow]="boxShadowMedium"
                            >
                              {{ 'theme.item.preview.service-message.example' | i18n }}
                            </div>
                          </div>
                          <div class="message-row user">
                            <div
                              class="message user"
                              [style.background]="customerBubbleBg"
                              [style.color]="customerBubbleText"
                              [style.border-radius]="bubbleRadius"
                              [style.box-shadow]="boxShadowMedium"
                            >
                              {{ 'theme.item.preview.user-message.example' | i18n }}
                            </div>
                            <span class="avatar"></span>
                          </div>
                        </div>
                        <div class="chat-input" [style.background]="footerBg">
                          <div class="input-with-action">
                            <input
                              nz-input
                              class="preview-input"
                              [placeholder]="'theme.item.preview.input-placeholder' | i18n"
                              testId="personal-webchat-theme-preview-input"
                            />
                            <button
                              nz-button
                              nzType="primary"
                              class="send-btn"
                              [style.background-color]="primaryColor"
                              [style.border-color]="primaryColor"
                              testId="personal-webchat-theme-preview-send-button"
                            >
                              <i nz-icon nzType="send" nzTheme="outline"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="preview-note">{{ 'theme.item.preview.note' | i18n }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </nz-tab>
            <nz-tab [nzTitle]="'servicenumber.webchat.tab.monitorConfig' | i18n" [testId]="'personal-webchat-tab-monitor-config'">
              <div class="monitor-config monitor-config-shell">
                <div class="tab-lead tab-lead-inline">
                  <div>
                    <h3 class="tab-lead-title">{{ 'servicenumber.webchat.monitor.title' | i18n }}</h3>
                    <div class="tab-lead-desc">{{ 'servicenumber.webchat.monitor.tip' | i18n }}</div>
                  </div>
                </div>
                <div class="monitor-header">
                  <div class="right">
                    <button nz-button nzType="primary" (click)="openAddRule()" testId="personal-webchat-monitor-add-rule-button">
                      <i nz-icon nzType="plus"></i>
                      {{ 'servicenumber.webchat.monitor.addRule' | i18n }}
                    </button>
                  </div>
                </div>

                <div class="monitor-grid">
                  <nz-card class="rule-card" *ngFor="let r of rules; let i = index" nzSize="small" [nzBordered]="true">
                    <div class="card-head">
                      <div class="title">
                        <span class="name">{{ r.name }}</span>
                        <nz-tag [nzColor]="'gold'" class="priority-tag">#{{ r.priority }}</nz-tag>
                        <nz-tag [nzColor]="r.enabled ? 'green' : 'default'">
                          {{
                            r.enabled ? ('servicenumber.webchat.monitor.enabled' | i18n) : ('servicenumber.webchat.monitor.disabled' | i18n)
                          }}
                        </nz-tag>
                      </div>
                      <div class="ops">
                        <a
                          nz-tooltip
                          [nzTooltipTitle]="'servicenumber.webchat.monitor.edit' | i18n"
                          (click)="openEditRule(i)"
                          class="op"
                          [testId]="'personal-webchat-monitor-edit-rule-' + i"
                        >
                          <i nz-icon nzType="edit"></i>
                        </a>
                        <a
                          nz-tooltip
                          [nzTooltipTitle]="'servicenumber.webchat.monitor.delete' | i18n"
                          (click)="deleteRule(i)"
                          class="op"
                          [testId]="'personal-webchat-monitor-delete-rule-' + i"
                        >
                          <i nz-icon nzType="delete"></i>
                        </a>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="subsection">
                        <div class="sub-title"
                          ><i nz-icon nzType="thunderbolt"></i> {{ 'servicenumber.webchat.monitor.section.conditions' | i18n }}</div
                        >
                        <ul class="cond-list">
                          <li *ngIf="r.pageMatchEnabled">
                            {{ 'servicenumber.webchat.monitor.pageMatch.label' | i18n }}：{{
                              r.pageMatchType === 'url'
                                ? ('servicenumber.webchat.monitor.pageMatch.urlContains' | i18n)
                                : ('servicenumber.webchat.monitor.pageMatch.titleContains' | i18n)
                            }}「{{ r.pageMatchKeyword }}」
                          </li>
                          <li *ngIf="r.dwellEnabled"
                            >{{ 'servicenumber.webchat.monitor.dwell.label' | i18n }}：≥ {{ r.dwellSeconds }}
                            {{ 'servicenumber.webchat.unit.seconds' | i18n }}</li
                          >
                          <li *ngIf="r.scrollEnabled"
                            >{{ 'servicenumber.webchat.monitor.scroll.label' | i18n }}：≥ {{ r.scrollPercent
                            }}{{ 'servicenumber.webchat.unit.percent' | i18n }}</li
                          >
                        </ul>
                      </div>
                      <div class="subsection">
                        <div class="sub-title"
                          ><i nz-icon nzType="message"></i> {{ 'servicenumber.webchat.monitor.section.behavior' | i18n }}</div
                        >
                        <div class="behavior">
                          <div class="behavior-item talk-content">
                            <span class="behavior-label">{{ 'servicenumber.webchat.monitor.content.label' | i18n }}</span>
                            <span class="behavior-value">{{ r.content || ('servicenumber.webchat.monitor.content.unfilled' | i18n) }}</span>
                          </div>
                          <div class="behavior-item anim">
                            <span class="behavior-label">{{ 'servicenumber.webchat.monitor.buttonAnim.label' | i18n }}</span>
                            <span class="behavior-value">{{
                              r.buttonAnim === 'pulse'
                                ? ('servicenumber.webchat.anim.pulse' | i18n)
                                : r.buttonAnim === 'bounce'
                                  ? ('servicenumber.webchat.anim.bounce' | i18n)
                                  : ('servicenumber.webchat.anim.none' | i18n)
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </nz-card>
                </div>
              </div>
            </nz-tab>
          </nz-tabset>
          <nz-modal
            [(nzVisible)]="ruleModalVisible"
            [nzTitle]="
              editingRuleIndex === null
                ? ('servicenumber.webchat.monitor.modal.addTitle' | i18n)
                : ('servicenumber.webchat.monitor.modal.editTitle' | i18n)
            "
            [nzWidth]="600"
            [nzBodyStyle]="{ padding: '30px', color: '#333' }"
            nzClassName="rule-modal"
            (nzOnCancel)="closeRuleModal()"
            [nzFooter]="modalFooter"
            testId="personal-webchat-monitor-rule-modal"
          >
            <ng-template #modalFooter>
              <button nz-button class="rule-modal-btn" (click)="closeRuleModal()" testId="personal-webchat-monitor-rule-cancel-button">{{
                'servicenumber.webchat.monitor.modal.cancel' | i18n
              }}</button>
              <button
                nz-button
                nzType="primary"
                class="rule-modal-btn"
                [disabled]="!isRuleValid()"
                (click)="saveRule()"
                testId="personal-webchat-monitor-rule-save-button"
                >{{ 'servicenumber.webchat.monitor.modal.save' | i18n }}</button
              >
            </ng-template>

            <ng-container *nzModalContent>
              <form class="rule-form" #ruleForm="ngForm" testId="personal-webchat-monitor-rule-form">
                <div class="rule-modal-section rule-modal-section-bordered">
                  <div class="rule-modal-grid rule-modal-grid-single">
                    <div nz-form-item class="span-2">
                      <div nz-form-label class="rule-modal-label"
                        ><label class="rule-modal-required-label"
                          ><span class="required-mark">*</span>{{ 'servicenumber.webchat.monitor.form.name.label' | i18n }}</label
                        ></div
                      >
                      <div nz-form-control>
                        <input
                          class="rule-modal-input"
                          nz-input
                          [(ngModel)]="newRule.name"
                          name="ruleName"
                          required
                          [placeholder]="'servicenumber.webchat.monitor.form.name.placeholder' | i18n"
                          testId="personal-webchat-monitor-rule-name-input"
                        />
                      </div>
                    </div>
                    <div nz-form-item>
                      <div nz-form-label class="rule-modal-label"
                        ><label>{{ 'servicenumber.webchat.monitor.priority.label' | i18n }}</label></div
                      >
                      <div nz-form-control>
                        <div class="rule-modal-inline">
                          <nz-input-number
                            class="rule-modal-number priority-number"
                            [(ngModel)]="newRule.priority"
                            name="priority"
                            [nzMin]="0"
                            [nzStep]="1"
                            [nzPrecision]="0"
                            testId="personal-webchat-rule-priority-input"
                          />
                          <span class="form-help">{{ 'servicenumber.webchat.monitor.priority.help' | i18n }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rule-modal-section rule-modal-section-bordered">
                  <h4 class="section-title">{{ 'servicenumber.webchat.monitor.section.conditions' | i18n }}</h4>
                  <div class="rule-modal-grid rule-modal-grid-single">
                    <div nz-form-item>
                      <div nz-form-label class="rule-modal-label">
                        <div class="rule-modal-label-stack">
                          <label class="rule-modal-required-label">
                            <span class="required-mark">*</span>
                            <span>{{ 'servicenumber.webchat.monitor.pageMatch.label' | i18n }}</span>
                          </label>
                          <span class="rule-modal-helper-text">{{ 'servicenumber.webchat.monitor.pageMatch.requiredHint' | i18n }}</span>
                        </div>
                      </div>
                      <div nz-form-control>
                        <div class="rule-modal-inline">
                          <nz-select
                            id="pageMatchTypeSelect"
                            class="rule-modal-select page-type-select"
                            [(ngModel)]="newRule.pageMatchType"
                            name="pageMatchType"
                            testId="personal-webchat-monitor-rule-page-match-type-select"
                          >
                            <nz-option [nzValue]="'url'" [nzLabel]="'servicenumber.webchat.monitor.pageMatch.urlContains' | i18n" />
                            <nz-option [nzValue]="'title'" [nzLabel]="'servicenumber.webchat.monitor.pageMatch.titleContains' | i18n" />
                          </nz-select>
                          <input
                            class="rule-modal-input rule-modal-input-flex"
                            nz-input
                            [(ngModel)]="newRule.pageMatchKeyword"
                            name="pageMatchKeyword"
                            required
                            [placeholder]="'servicenumber.webchat.monitor.pageMatch.placeholder' | i18n"
                            testId="personal-webchat-monitor-rule-page-match-keyword-input"
                          />
                        </div>
                      </div>
                    </div>

                    <div nz-form-item>
                      <div class="rule-trigger-card-list">
                        <div class="rule-trigger-card" [class.is-active]="newRule.dwellEnabled" [class.is-inactive]="!newRule.dwellEnabled">
                          <div nz-form-label class="rule-modal-label">
                            <div class="rule-modal-trigger-label">
                              <label nz-checkbox [(ngModel)]="newRule.dwellEnabled" name="dwellEnabled" class="rule-modal-checkbox-label">
                                <span>{{ 'servicenumber.webchat.monitor.dwell.label' | i18n }}</span>
                              </label>
                              <span class="rule-modal-trigger-required">{{
                                'servicenumber.webchat.monitor.trigger.oneOfRequired' | i18n
                              }}</span>
                            </div>
                          </div>
                          <div nz-form-control>
                            <div class="rule-modal-inline">
                              <span class="unit-prefix">{{ 'servicenumber.webchat.monitor.dwellPrefix' | i18n }}</span>
                              <nz-input-number
                                class="rule-modal-number"
                                [(ngModel)]="newRule.dwellSeconds"
                                name="dwellSeconds"
                                [nzMin]="1"
                                [nzMax]="3600"
                                [nzDisabled]="!newRule.dwellEnabled"
                                testId="personal-webchat-rule-dwell-seconds-input"
                              />
                              <span class="unit">{{ 'servicenumber.webchat.unit.seconds' | i18n }}</span>
                            </div>
                          </div>
                        </div>

                        <div
                          class="rule-trigger-card"
                          [class.is-active]="newRule.scrollEnabled"
                          [class.is-inactive]="!newRule.scrollEnabled"
                        >
                          <div nz-form-label class="rule-modal-label">
                            <label nz-checkbox [(ngModel)]="newRule.scrollEnabled" name="scrollEnabled" class="rule-modal-checkbox-label">{{
                              'servicenumber.webchat.monitor.scroll.label' | i18n
                            }}</label>
                          </div>
                          <div nz-form-control>
                            <div class="rule-modal-inline">
                              <span class="unit-prefix">{{ 'servicenumber.webchat.monitor.scrollPrefix' | i18n }}</span>
                              <nz-input-number
                                class="rule-modal-number"
                                [(ngModel)]="newRule.scrollPercent"
                                name="scrollPercent"
                                [nzMin]="1"
                                [nzMax]="100"
                                [nzDisabled]="!newRule.scrollEnabled"
                                testId="personal-webchat-rule-scroll-percent-input"
                              />
                              <span class="unit">{{ 'servicenumber.webchat.unit.percent' | i18n }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="rule-modal-helper-text rule-modal-helper-text-top">{{
                        'servicenumber.webchat.monitor.trigger.detailHint' | i18n
                      }}</div>
                    </div>
                  </div>
                </div>

                <div class="rule-modal-section">
                  <h4 class="section-title">{{ 'servicenumber.webchat.monitor.section.behavior' | i18n }}</h4>
                  <div nz-form-item class="span-2">
                    <div nz-form-label class="rule-modal-label"
                      ><label class="rule-modal-required-label"
                        ><span class="required-mark">*</span>{{ 'servicenumber.webchat.monitor.content.label' | i18n }}</label
                      ></div
                    >
                    <div nz-form-control>
                      <textarea
                        class="rule-modal-input"
                        nz-input
                        [(ngModel)]="newRule.content"
                        name="content"
                        required
                        rows="3"
                        [placeholder]="'servicenumber.webchat.monitor.content.placeholder' | i18n"
                        testId="personal-webchat-monitor-rule-content-textarea"
                      ></textarea>
                    </div>
                  </div>
                  <div nz-form-item>
                    <div nz-form-label class="rule-modal-label rule-modal-label-spaced"
                      ><label class="rule-modal-required-label"
                        ><span class="required-mark">*</span>{{ 'servicenumber.webchat.monitor.buttonAnim.label' | i18n }}</label
                      ></div
                    >
                    <div nz-form-control>
                      <nz-select
                        id="buttonAnimSelect"
                        class="rule-modal-select button-anim-select"
                        [(ngModel)]="newRule.buttonAnim"
                        name="buttonAnim"
                        required
                        testId="personal-webchat-monitor-rule-button-anim-select"
                      >
                        <nz-option [nzValue]="'pulse'" [nzLabel]="'servicenumber.webchat.anim.pulse' | i18n" />
                        <nz-option [nzValue]="'bounce'" [nzLabel]="'servicenumber.webchat.anim.bounce' | i18n" />
                        <nz-option [nzValue]="'none'" [nzLabel]="'servicenumber.webchat.anim.none' | i18n" />
                      </nz-select>
                    </div>
                  </div>
                </div>
              </form>
            </ng-container>
          </nz-modal>
          <!-- WebChat 分享弹窗 -->
          <nz-modal
            [(nzVisible)]="shareQrModalVisible"
            [nzTitle]="'servicenumber.webchat.share.qrTitle' | i18n"
            (nzOnCancel)="closeShareQrModal()"
            [nzFooter]="shareQrFooterTpl"
            [nzWidth]="520"
            nzClassName="webchat-share-qr-modal"
            testId="personal-webchat-share-qr-modal"
          >
            <ng-container *nzModalContent>
              <div class="webchat-share-modal-desc">{{ 'servicenumber.webchat.share.qrDesc' | i18n }}</div>
              <div class="webchat-link-mode-block">
                <div class="webchat-link-mode-label">{{ 'servicenumber.webchat.share.loginMode.label' | i18n }}</div>
                <nz-radio-group
                  class="webchat-link-mode-group"
                  [(ngModel)]="shareLoginMode"
                  (ngModelChange)="onShareLoginModeChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  testId="personal-webchat-share-qr-login-mode-radio"
                >
                  <label nz-radio nzValue="anonymous">{{ 'servicenumber.webchat.share.loginMode.anonymous' | i18n }}</label>
                  <label nz-radio nzValue="mobile">{{ 'servicenumber.webchat.share.loginMode.mobile' | i18n }}</label>
                </nz-radio-group>
              </div>
              <div class="webchat-share-qr-box">
                <nz-spin [nzSpinning]="shareQrGenerating">
                  <img *ngIf="shareQrCodeDataUrl" [src]="shareQrCodeDataUrl" alt="WebChat QR code" />
                  <div class="webchat-share-qr-empty" *ngIf="!shareQrCodeDataUrl">{{ 'servicenumber.webchat.share.noUrl' | i18n }}</div>
                </nz-spin>
              </div>
            </ng-container>
            <ng-template #shareQrFooterTpl>
              <button
                nz-button
                (click)="downloadShareQr()"
                [disabled]="!currentWebchatShareUrl"
                testId="personal-webchat-setting-download-qr-button"
              >
                <i nz-icon nzType="download"></i>
                {{ 'servicenumber.webchat.share.downloadQr' | i18n }}
              </button>
              <button
                nz-button
                nzType="primary"
                (click)="copyWebchatShareUrl()"
                [disabled]="!currentWebchatShareUrl"
                testId="personal-webchat-setting-copy-qr-url-button"
              >
                <i nz-icon nzType="copy"></i>
                {{ 'servicenumber.webchat.share.copyUrl' | i18n }}
              </button>
            </ng-template>
          </nz-modal>

          <nz-modal
            [(nzVisible)]="shareLinkModalVisible"
            [nzTitle]="'servicenumber.webchat.share.fullLinkTitle' | i18n"
            (nzOnCancel)="shareLinkModalVisible = false"
            [nzFooter]="shareLinkFooterTpl"
            [nzWidth]="620"
            nzClassName="webchat-share-link-modal"
            testId="personal-webchat-share-link-modal"
          >
            <ng-container *nzModalContent>
              <div class="webchat-share-modal-desc">{{ 'servicenumber.webchat.share.fullLinkDesc' | i18n }}</div>
              <div class="webchat-link-mode-block">
                <div class="webchat-link-mode-label">{{ 'servicenumber.webchat.share.loginMode.label' | i18n }}</div>
                <nz-radio-group
                  class="webchat-link-mode-group"
                  [(ngModel)]="shareLoginMode"
                  (ngModelChange)="onShareLoginModeChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  testId="personal-webchat-share-link-login-mode-radio"
                >
                  <label nz-radio nzValue="anonymous">{{ 'servicenumber.webchat.share.loginMode.anonymous' | i18n }}</label>
                  <label nz-radio nzValue="mobile">{{ 'servicenumber.webchat.share.loginMode.mobile' | i18n }}</label>
                </nz-radio-group>
              </div>
              <label class="webchat-share-url-label">{{ 'servicenumber.webchat.share.fullUrlLabel' | i18n }}</label>
              <input
                nz-input
                readonly
                [ngModel]="currentWebchatShareUrl"
                class="webchat-share-url-input"
                testId="personal-webchat-setting-share-url-input"
              />
            </ng-container>
            <ng-template #shareLinkFooterTpl>
              <button
                nz-button
                nzType="primary"
                (click)="copyWebchatShareUrl()"
                [disabled]="!currentWebchatShareUrl"
                testId="personal-webchat-setting-copy-share-url-button"
              >
                <i nz-icon nzType="copy"></i>
                {{ 'servicenumber.webchat.share.copyUrl' | i18n }}
              </button>
            </ng-template>
          </nz-modal>

          <!-- 集成代码弹窗 -->
          <nz-modal
            [(nzVisible)]="integrationCodeModalVisible"
            [nzTitle]="'servicenumber.webchat.integration.title' | i18n"
            (nzOnCancel)="integrationCodeModalVisible = false"
            [nzFooter]="integrationFooterTpl"
            [nzWidth]="820"
            nzClassName="integration-modal"
            testId="personal-webchat-integration-code-modal"
          >
            <ng-container *nzModalContent>
              <div
                class="integration-tip"
                style="
                  margin: 12px 0;
                  padding: 10px 12px;
                  border: 1px solid #91d5ff;
                  border-radius: 12px;
                  background: #e6f7ff;
                  color: #333;
                  line-height: 1.6;
                "
              >
                {{ 'servicenumber.webchat.integration.tip.intro' | i18n }}
                <code>&lt;/body&gt;</code>
                {{ 'servicenumber.webchat.integration.tip.tail' | i18n }}
              </div>
              <pre class="code-block"><code>{{ integrationCodeSnippet }}</code></pre>
            </ng-container>
            <ng-template #integrationFooterTpl>
              <button nz-button (click)="integrationCodeModalVisible = false" testId="personal-webchat-setting-integration-close-button">{{
                'servicenumber.webchat.integration.close' | i18n
              }}</button>
              <button
                nz-button
                class="copy-btn"
                (click)="copyIntegrationCode()"
                testId="personal-webchat-setting-integration-copy-button"
                >{{ 'servicenumber.webchat.integration.copyCode' | i18n }}</button
              >
            </ng-template>
          </nz-modal>
        </div>
      </div>
      <div class="mobile-desktop-mask" *ngIf="showMobileDesktopPrompt">
        <div class="mobile-desktop-mask-backdrop"></div>
        <div class="mobile-desktop-mask-dialog">
          <div class="mobile-desktop-mask-icon">
            <i nz-icon nzType="desktop" nzTheme="outline"></i>
          </div>
          <div class="mobile-desktop-mask-title">{{ 'servicenumber.webchat.mobilePrompt.title' | i18n }}</div>
          <div class="mobile-desktop-mask-desc">{{ 'servicenumber.webchat.mobilePrompt.desc' | i18n }}</div>
          <div class="mobile-desktop-mask-actions">
            <button
              nz-button
              nzType="primary"
              class="mobile-desktop-mask-btn"
              (click)="dismissMobileDesktopPrompt()"
              testId="personal-webchat-setting-mobile-prompt-close-button"
            >
              {{ 'common.close' | i18n }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </nz-spin>
</div>
